import { Dialog, DialogTitle } from "@/components";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import { WalletSchema } from "../types";

interface ModalProps {
  handleOpen: () => void;
  handleClose: () => void;
  isOpen: boolean;
  wallet: WalletSchema;
}

export function FundWallet({ handleClose, isOpen, wallet }: ModalProps) {
  function onCopy(text: string) {
    if (!text) return;
    navigator.clipboard.writeText(text);
    toast.success("Copied!");
  }

  return (
    <Dialog
      className="!bg-[#f5f5fb]"
      centered
      size="lg"
      open={isOpen}
      onClose={handleClose}>
      <div className="flex justify-between items-start py-4">
        <DialogTitle>Fund Wallet</DialogTitle>
        <button onClick={handleClose} className="text-gray-500">
          &#x2715;
        </button>
      </div>
      <div className="w-[300px] sm:w-[400px] bg-white p-4 rounded-lg ">
        <p className="text-sm font-semibold">Deposit via bank transfer</p>
        <div className="mt-6 space-y-4">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-400 font-normal text-sm">
                Account Number
              </p>
              <p className="font-semibold text-base leading-6">
                {wallet.account_number}
              </p>
            </div>
            <ClipboardDocumentIcon
              onClick={() => onCopy(wallet.account_number)}
              className="h-5 w-5 ml-2 text-gray-500 hover:text-primary cursor-pointer"
            />
          </div>
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-400 font-normal text-sm">Bank Name</p>
              <p className="font-semibold text-base leading-6">
                {wallet.bank_name}
              </p>
            </div>
            <ClipboardDocumentIcon
              onClick={() => onCopy(wallet.bank_name)}
              className="h-5 w-5 ml-2 text-gray-500 hover:text-primary cursor-pointer"
            />
          </div>
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-400 font-normal text-sm">Account Name</p>
              <p className="font-semibold text-base leading-6">
                {wallet.account_name}
              </p>
            </div>
            <ClipboardDocumentIcon
              onClick={() => onCopy(wallet.account_name)}
              className="h-5 w-5 ml-2 text-gray-500 hover:text-primary cursor-pointer"
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default FundWallet;
